import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

export interface NewMessageIndicatorProps {
  show: boolean;
  onPress: () => void;
  bottomOffset?: number;
}

/**
 * "New Message" floating indicator button.
 *
 * Appears when unread messages arrive while the user is scrolled up.
 * Tapping it triggers the parent's scroll-to-first-new-message callback.
 *
 * Extracted from ChatDetail.tsx / MyChatDetail.tsx so it can be
 * shared across web and mobile screens and properly unit-tested.
 */
const NewMessageIndicator: React.FC<NewMessageIndicatorProps> = ({
  show,
  onPress,
  bottomOffset = 11,
}) => {
  if (!show) return null;

  return (
    <TouchableOpacity
      testID='new-message-indicator'
      style={[styles.container, { bottom: bottomOffset }]}
      activeOpacity={0.2}
      onPress={onPress}>
      <Box
        borderColor='grey02'
        flexDirection='row'
        style={styles.pill}
        alignItems='center'
        justifyContent='center'
        pointerEvents='none'
        backgroundColor='grey01'>
        <Text variant='labelSmall' marginLeft='xxs'>
          New Message
        </Text>
        <Icon
          name='ArrowDown'
          variant='m'
          color='textPrimary'
          marginTop='xxxs'
        />
      </Box>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 150,
    position: 'absolute',
    right: 17,
  },
  pill: {
    borderRadius: 21,
    height: 35,
    shadowColor: 'black',
    shadowOpacity: 0.12,
    shadowOffset: { width: 2, height: 2 },
    shadowRadius: 12,
  },
});

export default NewMessageIndicator;
